"use client";

import useFeature from "@casino/legacy/client/hooks/feature/useFeature";

const useIsRegistrationDisabled = () => !!useFeature("isRegistrationDisabled");

export default useIsRegistrationDisabled;
